function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "televison"
}, /*#__PURE__*/React.createElement("path", {
  d: "m18 6h-3.586l2.293-2.293c.391-.391.391-1.023 0-1.414s-1.023-.391-1.414 0l-3.293 3.293-3.293-3.293c-.391-.391-1.023-.391-1.414 0s-.391 1.023 0 1.414l2.293 2.293h-3.586c-1.654 0-3 1.346-3 3v8c0 1.654 1.346 3 3 3h.382l-.276.553c-.247.494-.047 1.095.447 1.342.143.071.296.105.446.105.367 0 .72-.202.896-.553l.723-1.447h6.764l.724 1.447c.175.351.528.553.895.553.15 0 .303-.034.446-.105.494-.247.694-.848.447-1.342l-.276-.553h.382c1.654 0 3-1.346 3-3v-8c0-1.654-1.346-3-3-3zm1 11c0 .552-.448 1-1 1h-12c-.551 0-1-.448-1-1v-8c0-.552.449-1 1-1h12c.552 0 1 .448 1 1z"
}));

var Svg119Television = function Svg119Television(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 512,
    viewBox: "0 0 24 24",
    width: 512,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(Svg119Television, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/119-television.8f7e0ac6.svg";
export { ForwardRef as ReactComponent };